import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RegistrationComponent } from './registration.component';
 
const RegistrationRoutes: Routes = [
    {
        path: '',
        component: RegistrationComponent,
    }, {
        path: '**',
        redirectTo: ''
    }
]

@NgModule({
    imports: [RouterModule.forChild(RegistrationRoutes)],
    exports: [RouterModule]
})

export class RegistrationRouting { }


// WEBPACK FOOTER //
// ./src/app/pages/registration/registration.routing.ts